export const StateSettingsHeader = () => (
  <div className='flex items-start rounded-t-large border border-b-0 border-shade-10 bg-white px-7 py-6'>
    {/* border-width: 1 1 0 1 sides → border + border-b-0; border-radius: 8px 8px 0 0 → rounded-t-large */}
    <div className='flex flex-col gap-1'>
      <span className='text-xl font-semibold leading-7 text-text-dark'>States information</span>
      <span className='text-sm font-normal leading-5 text-text-light'>
        These settings determine service availability and visit requirements for patients based on their state.
      </span>
    </div>
  </div>
)
